import { makeStyles, Typography } from '@paintscout/ui'
import classNames from 'classnames'
import moment from 'moment'
import React from 'react'
import type { HeaderProps } from 'react-big-calendar'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(0.25)
  },
  dayName: {
    color: theme.paintscout.palette.brand.Neutral.P60,
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 500,
    lineHeight: 1
  },
  todayDayName: {
    color: theme.paintscout.palette.brand.Neutral.P30
  },
  dayNumber: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '24px',
    height: '24px',
    padding: theme.spacing(0, 0.75),
    borderRadius: theme.borderRadius.md,
    color: theme.paintscout.palette.brand.Neutral.P60,
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 600,
    lineHeight: 1
  },
  todayDayNumber: {
    backgroundColor: theme.paintscout.palette.primary,
    color: theme.palette.common.white
  }
}))

export function WeekColumnHeader(props: HeaderProps) {
  const classes = useStyles()
  const momentDate = moment(props.date)
  const isToday = momentDate.isSame(moment(), 'day')

  return (
    <div className={classes.root}>
      <Typography className={classNames(classes.dayName, { [classes.todayDayName]: isToday })} component="span">
        {momentDate.format('ddd')}
      </Typography>
      <span
        className={classNames(classes.dayNumber, {
          [classes.todayDayNumber]: isToday
        })}
      >
        {momentDate.format('D')}
      </span>
    </div>
  )
}
